import React, { useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { motion } from "framer-motion";

// Ikonice
import BurgerImg from "../../Assets/Icons/burger.png";
import ChickenImg from "../../Assets/Icons/fried-chicken.png";
import BBQImg from "../../Assets/Icons/grill.png";
import TacosImg from "../../Assets/Icons/tacos.png";
import PommesImg from "../../Assets/Icons/pommes.png";
import SouceImg from "../../Assets/Icons/souce.png";
import FishImg from "../../Assets/Icons/fish.png";
import DrinksImg from "../../Assets/Icons/drinks.png";

const menuData = {
  burgeri: [
    {
      id: 1,
      name: "Bacon Burger",
      ingredients:
        "Juneća pljeskavica 150-180g, karamelizirani luk, slanina, cheedar sir, umak od senfa, rikola, brioche pecivo",
      price: "6.50 €",
    },
    {
      id: 2,
      name: "Yummy Grub Burger",
      ingredients:
        "Juneća pljeskavica 150-180g, namaz od sira, slanina, jaje, cheedar sir, umak od senfa, rikola, rajčica, brioche pecivo",
      price: "5.50 €",
    },
  ],
  crispyBox: [
    {
      id: 3,
      name: "Chicken wing",
      ingredients: "small box 200g",
      price: "6.50 €",
    },
    {
      id: 4,
      name: "Chicken wings",
      ingredients: "big box 400g",
      price: "11.50 €",
    },
    {
      id: 5,
      name: "Chicken stripes",
      ingredients: "small box",
      price: "7.60 €",
    },
  ],
  rostilj: [
    {
      id: 6,
      name: "Čevapčići ( junietina i ovčetina)",
      ingredients: "10kom čevapa, luk, lepinja",
      price: "12.00 €",
    },
  ],
  salate: [
    {
      id: 7,
      name: "Cezar Salata",
      ingredients: "Piletina, zelena salata, dresing",
      price: "8.00 €",
    },
  ],
  prilozi: [
    { id: 8, name: "Pommes Frites", ingredients: "300g", price: "1.50€" },
    {
      id: 9,
      name: "Pommes Frites",
      ingredients: "Chilli cheese",
      price: "2.80€",
    },
  ],
  dodaci: [
    { id: 10, name: "Umak blagi", ingredients: "", price: "0.80€" },
    { id: 11, name: "Umak chilly", ingredients: "", price: "0.80€" },
    { id: 12, name: "Umak tartufo", ingredients: "", price: "0.80€" },
    { id: 13, name: "Umak od senfa", ingredients: "", price: "0.80€" },
    { id: 14, name: "Kajmak", ingredients: "", price: "1.00€" },
    { id: 15, name: "Karamelizirani luk", ingredients: "", price: "0.80€" },
    { id: 16, name: "Jaje", ingredients: "Kuhano ili pećeno", price: "0.60€" },
    { id: 17, name: "Panceta", ingredients: "", price: "0.80€" },
    { id: 18, name: "Feta sir", ingredients: "", price: "0.60€" },
    {
      id: 19,
      name: "Salata",
      ingredients: "rikola ili mješavina zelene salate",
      price: "0.80€",
    },
    { id: 20, name: "Lepinja", ingredients: "", price: "1.00€" },
    { id: 21, name: "Kruh", ingredients: "", price: "0.50€" },
  ],
  petkom: [
    {
      id: 22,
      name: "Pržene lignje",
      ingredients: "pommes ili blitva s krumpirom",
      price: "7.20€",
    },
    {
      id: 23,
      name: "Pržene srdelice",
      ingredients: "pommes ili blitva s krumpirom",
      price: "6.00€",
    },
    {
      id: 24,
      name: "Prženi gavuni",
      ingredients: "pommes ili blitva s krumpirom",
      price: "5.80€",
    },
    {
      id: 25,
      name: "Pržene papaline",
      ingredients: "pommes ili blitva s krumpirom",
      price: "5.50€",
    },
    {
      id: 26,
      name: "Pohani oslić",
      ingredients: "pommes ili blitva s krumpirom",
      price: "6.20€",
    },
  ],
  drinks: [
    { id: 27, name: "XIXO", ingredients: "sokovi 250ml", price: "1.00€" },
    {
      id: 28,
      name: "HELL",
      ingredients: "Energetski napitak 250ml",
      price: "1.20€",
    },
    { id: 29, name: "HELL ICE COFFE", ingredients: "250ml", price: "1.80€" },
    { id: 30, name: "Negazirana voda", ingredients: "250ml", price: "1.20€" },
    { id: 31, name: "PIVO", ingredients: "Limenka 0,5l", price: "2.20€" },
    { id: 32, name: "CIDER", ingredients: "Limenka 0,5l", price: "2.20 €" },
  ],
};

// Animacijske varijante
const titleVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const Menu = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="menu-page">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="main-title"
      >
        Meni
      </motion.h1>

      {/* SEKCIJA: BURGERI */}
      <section id="burgeri" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Burgeri</h2>
          <img className="icon-img" src={BurgerImg} alt="Burger ikonica" />
        </motion.div>
        {menuData.burgeri.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* SEKCIJA: CRISPY BOX */}
      <section id="crispyBox" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Chrispy Box</h2>
          <img className="icon-img" src={ChickenImg} alt="Piletina ikonica" />
        </motion.div>
        {menuData.crispyBox.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* SEKCIJA: ROŠTILJ */}
      <section id="rostilj" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Roštilj</h2>
          <img className="icon-img" src={BBQImg} alt="Roštilj ikonica" />
        </motion.div>
        {menuData.rostilj.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* SEKCIJA: SALATE */}
      <section id="salate" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Salads & Tortilla</h2>
          <img className="icon-img" src={TacosImg} alt="Tortilja ikonica" />
        </motion.div>
        {menuData.salate.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* SEKCIJA: PRILOZI */}
      <section id="ostalo" className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Prilozi</h2>
          <img className="icon-img" src={PommesImg} alt="Pomfrit ikonica" />
        </motion.div>
        {menuData.prilozi.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* SEKCIJA: DODACI */}
      <section className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Dodaci</h2>
          <img className="icon-img" src={SouceImg} alt="Umak ikonica" />
        </motion.div>
        {menuData.dodaci.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* SEKCIJA: PETKOM */}
      <section className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Petkom</h2>
          <img className="icon-img" src={FishImg} alt="Riba ikonica" />
        </motion.div>
        {menuData.petkom.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* SEKCIJA: PIĆA */}
      <section className="menu-section">
        <motion.div
          className="menu-title"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={titleVariants}
        >
          <h2>Pića</h2>
          <img className="icon-img" src={DrinksImg} alt="Sokovi ikonica" />
        </motion.div>
        {menuData.drinks.map((item, index) => (
          <motion.div
            key={item.id}
            className="menu-item"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={itemVariants}
            transition={{ delay: index * 0.1 }}
          >
            <div className="item-info">
              <h3>{item.name}</h3>
              <p className="ingredients">{item.ingredients}</p>
            </div>
            <p className="price">{item.price}</p>
          </motion.div>
        ))}
      </section>

      {/* FIKSNA NAVIGACIJA */}
      <div className="menu-bottom-nav">
        <Link smooth to="#burgeri">
          <img className="icon-img" src={BurgerImg} alt="ikona" /> Burgeri
        </Link>
        <Link smooth to="#crispyBox">
          <img className="icon-img" src={ChickenImg} alt="ikona" /> Crispy
        </Link>
        <Link smooth to="#rostilj">
          <img className="icon-img" src={BBQImg} alt="ikona" /> Roštilj
        </Link>
        <Link smooth to="#salate">
          <img className="icon-img" src={TacosImg} alt="ikona" /> Salads
        </Link>
        <Link smooth to="#ostalo">
          <img className="icon-img" src={PommesImg} alt="ikona" /> Ostalo
        </Link>
      </div>
    </div>
  );
};

export default Menu;
